const products = [
  {
    title: "FRCOphth Part 1",
    id: "frcophth1",
    price: 179,
    comingSoon: false,
    description:
      "6,000+ total questions (5,000+ exam-style MCQs & 900+ high-yield questions) covering every module and every syllabus area for Part 1—questions match the wording and format of real papers. Timed practice and mock exams, detailed explanations, and analytics.",
    length: "6 months",
    css: "linear-gradient-3",
  },
  {
    title: "FRCOphth Part 2 (Written)",
    id: "frcophth2",
    price: 199,
    comingSoon: false,
    description:
      "11,550+ total questions (10,000+ clinically focused MCQs & 1,550+ high-yield questions) covering every module and every area of the Part 2 syllabus—exam-style stems that mirror real questions. Timed mock exams, management scenarios, and advanced coverage built for exam day.",
    length: "6 months",
    css: "linear-gradient-3",
  },
  {
    title: "MSRA",
    id: "msra",
    price: 50,
    comingSoon: false,
    description: "3,008 questions (2,380 clinical MCQs + 628 SJTs) across merged topic groups, medic-reviewed and aligned to real MSRA format and difficulty.",
    length: "6 months",
    css: "",
  },
  {
    title: "Interview Pack (ST1)",
    id: "interview_pack_st1",
    price: 149,
    comingSoon: false,
    description: "Interview pack with 79 Ophthalmology scenarios with actor briefs, candidate briefs, a mark scheme, and key points, to help perfect your Ophthalmology interviews.",
    length: "6 months",
    css: "linear-gradient-2",
  },
  {
    title: "Duke Elder Resource",
    id: "duke_elder",
    price: 120,
    comingSoon: false,
    description: "Ophthalmology in 1000 MCQs - A comprehensive MCQ-based revision resource for the Duke Elder Ophthalmology Examination",
    length: "Physical Book",
    css: "linear-gradient-3",
    purchasable: false,
    externalPurchaseUrl: "https://www.amazon.co.uk/Ophthalmology-1000-MCQs-Diya-Baker/dp/3032145708",
  },
  {
    title: "Interview Coaching",
    id: "interview_coaching",
    price: 349,
    comingSoon: false,
    showOnSignUp: false,
    checkoutUrl: "https://buy.stripe.com/dRmaEYdaG0HT0Wh5tk3Ru00?locale=en-GB&__embed_source=1",
    description:
      "1-to-1 interview coaching delivered by leading UK ophthalmologists—structured, high-quality preparation from clinicians who know the ST1 interview process inside out.",
    length: "full day (2 sessions - 10 hours total)",
    css: "linear-gradient-2",
  },
  {
    title: "Portfolio Builder",
    id: "portfolio_builder",
    price: 349,
    comingSoon: true,
    showOnSignUp: false,
    description: "1-to-1 expert portfolio review and question bank for trainee/junior doctors to build a portfolio to get to the Ophthalmology interview stage",
    length: "full day (2 sessions)",
    css: "linear-gradient-2",
  },
  // {
  //   title: "FRCOphth Part 2 Refraction",
  //   id: "frcophth2-refraction",
  //   price: 0,
  //   comingSoon: true,
  //   description:
  //     "Tests refraction skills, a crucial competency for ophthalmologist",
  //   css: "",
  // },
  // {
  //   title: "FRCOphth Part 2 Oral Exam",
  //   id: "frcophth2-oral",
  //   price: 0,
  //   comingSoon: true,
  //   description: "Based on the OST learning outcomes",
  //   css: "linear-gradient-2",
  // },
];

export default products;
